import React from 'react';
import update from 'immutability-helper';
import SelectInput from '../misc/SelectInput.js';
import States from '../misc/States.js';

class AdvancedOptions extends React.Component {
  _cityChanged = (event) => {
    const next = update(this.props.options, {
      city: {$set: event.target.value},
    });
    this.props.onChange(next);
  };

  _stateChanged = (event) => {
    const next = update(this.props.options, {
      state: {$set: event.target.value},
    });
    this.props.onChange(next);
  };

  render() {
    const {options} = this.props;
    return (
      <div className="row">
        <div className="col-xs-12 col-xs-offset-0 col-sm-offset-1 col-sm-10">
          <div className="form-group">
            <div className="col-xs-8">
              <input type="text" className="form-control" placeholder="City" value={options.city || ''} onChange={this._cityChanged}/>
            </div>
            <div className="col-xs-4">
              <SelectInput className="form-control" value={options.state || ''} onChange={this._stateChanged}>
                <option value="">State</option>
                {
                  States['US'].map(([value, label]) => (<option key={value} value={value}>{label}</option>))
                }
              </SelectInput>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdvancedOptions;
